import { useMutation } from '@apollo/client/react';
import { gql } from '@apollo/client';
import { toast } from 'sonner';

export const UPDATE_USER_MUTATION = gql`
  mutation UpdateUser($id: ID!, $input: UpdateUserInput!) {
    updateUser(id: $id, input: $input) {
      user {
        id
        email
        fullName
        role
        disabled
        disabledAt
        forcePasswordChange
        createdAt
        updatedAt
      }
    }
  }
`;

interface UpdateUserResponse {
  updateUser: {
    user: {
      id: string;
      email: string;
      fullName: string;
      role: string;
      disabled: boolean;
      disabledAt: string | null;
      forcePasswordChange: boolean;
      createdAt: string;
      updatedAt: string;
    };
  };
}

export function useUpdateUser(options?: { onCompleted?: () => void; onError?: (error: any) => void }) {
  const [updateUserMutation, { loading }] = useMutation<UpdateUserResponse>(UPDATE_USER_MUTATION, {
    onCompleted: options?.onCompleted,
    onError: (error: any) => {
      if (options?.onError) {
        options.onError(error);
      } else {
        const message = error.graphQLErrors?.[0]?.message || error.message || 'Falha ao atualizar usuário';
        toast.error(message);
      }
    },
  });

  const updateUser = (
    id: string,
    disabledAt?: string | null,
    role?: string,
    fullName?: string,
    email?: string
  ) => {
    const input: Record<string, unknown> = {};
    if (disabledAt !== undefined) input.disabledAt = disabledAt;
    if (role) input.role = role;
    if (fullName) input.fullName = fullName;
    if (email) input.email = email;

    return updateUserMutation({
      variables: { id, input },
    });
  };

  return { updateUser, loading };
}
